import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import TooltipComponent from '../../Info/Tooltip/TooltipComponent';

import {
  FaCardWrapper,
  HeadContent,
  FundNameContent,
  BalanceWrapper,
  DollarValue,
  Wrapper,
  InvestmentWrapper,
  FlexWrapper,
  AllocationRow,
  WrapperCard,
  ProfileImage,
  WrapperController,
  Advisorwrapper,
  Triangle,
  LastOn,
  DollarController,
  TooltipContainer
} from './styles';
import profileImage from '../../../assets/icons/profile-3.svg';
import { formatAmount } from '../../../utils/commonUtil';
import PropTypes from 'prop-types';
import { GeneralButton, CapsuleButton } from '../../Commons/commonComponents';


export function dateFormatter(milliseconds) {
  if (!milliseconds) return <span>&mdash;</span>;
  return moment(milliseconds).format('L');
}
function FaCard(props) {
  let faCardData = [...props.faCardData];
  if (props.filteredArray) {
    faCardData = props.filteredArray;
  }
  return (
    <WrapperCard>
      {faCardData.length &&
        faCardData.map((cardData) => (
          <FaCardWrapper data-test='faCard' key={cardData.accountNumber}>
            <Wrapper>
              <HeadContent
                text={`${
                  cardData.clientFirstName ? cardData.clientFirstName : null
                } ${
                  cardData.clientLasttName ? cardData.clientLasttName : null
                }`}
              >
                <span>
                  {cardData.clientFirstName ? cardData.clientFirstName : null}{' '}
                  {cardData.clientLasttName ? cardData.clientLasttName : null}
                </span>
                <WrapperController>
                  <ProfileImage src={profileImage} alt='profile_image' />
                  <Triangle />
                  <Advisorwrapper>
                    <div>
                      <span>Primary Advisor</span>
                      <p>
                        {cardData.clientPrefix} {cardData.clientFirstName}{' '}
                        {cardData.clientMiddleName} {cardData.clientLasttName}{' '}
                        {cardData.clientSuffix}
                      </p>
                    </div>
                    {cardData.saFirstName || cardData.saLastName ? (
                      <div>
                        <span>Secondary Advisor</span>
                        <p>
                          {cardData.saPrefix} {cardData.saFirstName}{' '}
                          {cardData.saMiddleName} {cardData.saLastName}{' '}
                          {cardData.saSuffix}
                        </p>
                      </div>
                    ) : null}
                  </Advisorwrapper>
                </WrapperController>
              </HeadContent>
              <FundNameContent noPadding>
                <TooltipContainer
                  className='dashboard-ellipsis'
                  placement='topLeft'
                  title={`${cardData.accountName}-${cardData.accountNumber}`}
                >
                  {cardData.accountName}
                  {` - `}
                  {cardData.accountNumber}
                </TooltipContainer>
              </FundNameContent>
              <BalanceWrapper>
                Current Balance
                <TooltipComponent
                  placement='bottom'
                  text="Balance in your donor-advised fund after the previous day's trading cycle is complete"
                />
              </BalanceWrapper>
              <DollarValue>
                {cardData.currentBalance ? (
                  formatAmount(cardData.currentBalance)
                ) : (
                  <div>{formatAmount(0)}</div>
                )}
              </DollarValue>
              <CapsuleButton
                text='View Full Details'
                onClick={() => props.popupRender(cardData)}
                disabled={cardData.investmentAllocation.investmentPools && cardData.investmentAllocation.investmentPools.length === 0}
              />
            </Wrapper>
            {
              <span className='tool-tip' tabindex='0'>
                <GeneralButton
                  width='100%'
                  mobWidth='100%'
                  type='primary'
                  text='VIEW ACCOUNT'
                  onClick={() => props.handleButtonClick(cardData)}
                />
              </span>
            }
          </FaCardWrapper>
        ))}
    </WrapperCard>
  );
}

FaCard.propTypes = {
  faCardData: PropTypes.arrayOf(
    PropTypes.shape({
      accountName: PropTypes.string.isRequired,
      accountNumber: PropTypes.string.isRequired,
      clientFirstName: PropTypes.string,
      clientLasttName: PropTypes.string,
      clientMiddleName: PropTypes.string,
      clientPrefix: PropTypes.string,
      clientSuffix: PropTypes.string,
      currentBalance: PropTypes.number,
      dateOpened: PropTypes.number,
      investmentAllocation: PropTypes.object,
      lastContributionDate: PropTypes.number,
      lastExchangeDate: PropTypes.number,
      lastGrantDate: PropTypes.number,
      pendingContribution: PropTypes.bool,
      pendingExchange: PropTypes.bool,
      pendingGrant: PropTypes.bool,
      role: PropTypes.string,
      saFirstName: PropTypes.string,
      saLastName: PropTypes.string,
      saMiddleName: PropTypes.string,
      saPrefix: PropTypes.string,
      saSuffix: PropTypes.string,
      state: PropTypes.string,
      ytd: PropTypes.object,
    })
  ).isRequired,
  filteredArray: PropTypes.array,
  popupRender: PropTypes.func,
  handleButtonClick: PropTypes.func,
};

export function sortedAllocation(investments) {
  if (investments.length > 0) {
    const tempInv = _.orderBy(
      investments,
      [
        function(investment) {
          return Number(investment.percentShare);
        },
      ],
      ['desc']
    );
    return tempInv.slice(0, 3).map((item) => (
      <FlexWrapper key={item.poolName}>
        <h5>
          {(Math.round(item.percentShare * 100) / 100).toFixed(2)}
          {`%`}
        </h5>
        <p>{item.poolName}</p>
      </FlexWrapper>
    ));
  }
  return (
    <FlexWrapper>
      <p>No Allocation Data</p>
    </FlexWrapper>
  );
}

function FaDetailedCard(props) {
  let faDetailCardData = [...props.faDetailCardData];
  if (props.filteredArray) {
    faDetailCardData = props.filteredArray;
  }
  return (
    <WrapperCard>
      {faDetailCardData &&
        faDetailCardData.map((cardData) => (
          <FaCardWrapper
            Long
            data-test='faDetailedCard'
            key={cardData.accountNumber * (Math.random() * 2)}
          >
            <Wrapper Long>
              <HeadContent
                text={`${
                  cardData.clientFirstName ? cardData.clientFirstName : null
                } ${
                  cardData.clientLasttName ? cardData.clientLasttName : null
                }`}
              >
                <span>
                  {cardData.clientFirstName ? cardData.clientFirstName : null}{' '}
                  {cardData.clientLasttName ? cardData.clientLasttName : null}
                </span>
                <WrapperController>
                  <ProfileImage src={profileImage} alt='advisor profile' />
                  <Triangle />
                  <Advisorwrapper>
                    <div>
                      <span>Primary Advisor</span>
                      <p>
                        {cardData.clientPrefix} {cardData.clientFirstName}{' '}
                        {cardData.clientMiddleName} {cardData.clientLasttName}
                        {cardData.clientSuffix
                          ? ', ' + cardData.clientSuffix
                          : null}
                      </p>
                    </div>
                    {cardData.saFirstName || cardData.saLastName ? (
                      <div>
                        <span>Secondary Advisor</span>
                        <p>
                          {cardData.saPrefix} {cardData.saFirstName}{' '}
                          {cardData.saMiddleName} {cardData.saLastName}{' '}
                          {cardData.saSuffix}
                        </p>
                      </div>
                    ) : null}
                  </Advisorwrapper>
                </WrapperController>
              </HeadContent>
              <FundNameContent noPadding>
                <TooltipContainer
                  className='dashboard-ellipsis'
                  placement='topLeft'
                  title={`${cardData.accountName}-${cardData.accountNumber}`}
                >
                  {cardData.accountName}
                  {` - `}
                  {cardData.accountNumber}
                </TooltipContainer>
              </FundNameContent>
              <BalanceWrapper currentBalance>
                Current Balance
                <TooltipComponent
                  placement='bottom'
                  text="Balance in your donor-advised fund after the previous day's trading cycle is complete"
                />
              </BalanceWrapper>
              <DollarValue Underlined currentBalance>
                {cardData.currentBalance ? (
                  formatAmount(cardData.currentBalance)
                ) : (
                  <div>{formatAmount(0)}</div>
                )}
              </DollarValue>
              {/* Grants YTD */}
              <DollarController>
                <BalanceWrapper currentBalance>
                  Grants YTD
                  {cardData.pendingGrant ? (
                    <TooltipComponent
                      placement='bottom'
                      text='You Have Pending Grants'
                    />
                  ) : null}
                </BalanceWrapper>
                <DollarValue Underlined>
                  {cardData.ytd ? (
                    formatAmount(cardData.ytd.grantsYtd)
                  ) : (
                    <div>&mdash;</div>
                  )}
                  <LastOn noPadding>
                    Last Grant on <br /> {dateFormatter(cardData.lastGrantDate)}
                  </LastOn>
                </DollarValue>
              </DollarController>
              {/* Contributions YTD */}
              <DollarController>
                <BalanceWrapper currentBalance>
                  Contributions YTD
                  {cardData.pendingContribution ? (
                    <TooltipComponent
                      placement='bottom'
                      text='You have Pending Contributions'
                    />
                  ) : null}
                </BalanceWrapper>
                <DollarValue Underlined>
                  {formatAmount(cardData.ytd.contributionYtd)}
                  <LastOn noPadding>
                    Last Contribution on <br />
                    {dateFormatter(cardData.lastContributionDate)}
                  </LastOn>
                </DollarValue>
              </DollarController>
              <AllocationRow>
                <BalanceWrapper>
                  Investment Allocation{' '}
                  {cardData.pendingExchange ? (
                    <TooltipComponent
                      placement='bottom'
                      text='You have Pending Exchanges'
                    />
                  ) : null}
                </BalanceWrapper>
                <LastOn exchanges>
                  Last Exchange on <br />
                  {dateFormatter(cardData.lastExchangeDate)}
                </LastOn>
                <InvestmentWrapper>
                  {cardData.investmentAllocation.investmentPools &&
                    sortedAllocation(
                      cardData.investmentAllocation.investmentPools
                    )}
                </InvestmentWrapper>
              </AllocationRow>
              <CapsuleButton
                text='View Full Details'
                onClick={() => props.popupRender(cardData)}
                disabled={cardData.investmentAllocation.investmentPools && cardData.investmentAllocation.investmentPools.length === 0}
              />
            </Wrapper>
            {
              <span className='tool-tip' tabIndex='0'>
                <GeneralButton
                  width='100%'
                  mobWidth='100%'
                  type='primary'
                  text='VIEW ACCOUNT'
                  onClick={() => props.handleButtonClick(cardData)}
                />
              </span>
            }
          </FaCardWrapper>
        ))}
    </WrapperCard>
  );
}
FaDetailedCard.propTypes = {
  faDetailCardData: PropTypes.arrayOf(
    PropTypes.shape({
      accountName: PropTypes.string.isRequired,
      accountNumber: PropTypes.string.isRequired,
      clientFirstName: PropTypes.string,
      clientLasttName: PropTypes.string,
      clientMiddleName: PropTypes.string,
      clientPrefix: PropTypes.string,
      clientSuffix: PropTypes.string,
      currentBalance: PropTypes.number,
      dateOpened: PropTypes.number,
      investmentAllocation: PropTypes.object,
      lastContributionDate: PropTypes.number,
      lastExchangeDate: PropTypes.number,
      lastGrantDate: PropTypes.number,
      pendingContribution: PropTypes.bool,
      pendingExchange: PropTypes.bool,
      pendingGrant: PropTypes.bool,
      role: PropTypes.string,
      saFirstName: PropTypes.string,
      saLastName: PropTypes.string,
      saMiddleName: PropTypes.string,
      saPrefix: PropTypes.string,
      saSuffix: PropTypes.string,
      state: PropTypes.string,
      ytd: PropTypes.object,
    })
  ).isRequired,
  filteredArray: PropTypes.array,
  popupRender: PropTypes.func,
  handleButtonClick: PropTypes.func,
};
export { FaCard, FaDetailedCard };
